export default __webpack_public_path__ + "static/media/explorer.8ca87c5a.svg";